import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'src/common/components/IconDS22';
import s from './PhotoInput.module.scss';

const PhotoInput = ({
  inputId,
  label,
  onChange,
}) => (
  <div className={s.root}>
    <label
      htmlFor={inputId}
      className={s.label}
    >
      <div className={s.iconWrapper}>
        <Icon
          id="plus"
          className={s.icon}
        />
      </div>
      {label}
    </label>
    <input
      id={inputId}
      name={inputId}
      type="file"
      accept="image/*"
      multiple
      onChange={({ target }) => {
        const input = target;
        onChange(input.files);
        // Reset the input's value so that the same image can be uploaded again without
        // needing to select a different image first.
        input.value = '';
      }}
      className={s.input}
    />
  </div>
);

PhotoInput.propTypes = {
  inputId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PhotoInput;
